<template>
  <div id="menuBar">
    <ul class="menu-item-list">
      <li class="menu-item" @click="expand" @keypress.enter="expand">
        <div class="item-button hamburger clickable">
          <p />
          <p />
          <p />
        </div>
        <div class="item-line" />
      </li>

      <li class="menu-item" @click="goBack" @keypress.enter="goBack">
        <div class="item-button clickable back">
          <p />
        </div>
        <div class="item-line" />
      </li>

      <li class="menu-item" @click="goDashboard" @keypress.enter="goDashboard">
        <div class="item-button clickable">
          <inline-svg :src="$assets.svg['icon-dashboard']" width="40%" />
        </div>
        <div class="item-line" />
      </li>

      <li class="bottom-items-start" />

      <li class="menu-item" @click="goProfile" @keypress.enter="goProfile">
        <div
          :class="{
            'item-button': true,
            clickable: true,
            active: currentFunction.key === 'profile',
          }"
        >
          <inline-svg :src="$assets.svg['icon-profile']" width="40%" />
        </div>
        <div class="item-line" />
      </li>

      <li class="menu-item" @click="logout" @keypress.enter="logout">
        <div class="item-button clickable">
          <inline-svg :src="$assets.svg['icon-logout']" width="40%" />
        </div>
        <div class="item-line" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    expand() {
      this.$emit('expand');
    },

    goBack() {
      this.$emit('goBack');
    },
    goDashboard() {
      this.$emit('goDashboard');
    },
    goProfile() {
      this.$emit('goProfile');
    },
    logout() {
      this.$emit('logout');
    },
  },
  computed: {
    currentFunction() {
      return this.$store.getters.currentFunction || {};
    },
  },
};
</script>
